import { isProblemError, type ProblemError } from './errors.ts'

/** A 404: the row is not there, which no retry changes — what a page says in place of a
 *  breakage. */
export function isNotFound(error: unknown): error is ProblemError {
  return isProblemError(error) && error.status === 404
}
